export const management_control = {
  id: 2,
  name: "Management Control & EE",
  slug: "management_control",
  status: "at risk",
  description: "Board participation, executive management, and employment equity compliance",
  deadline: "31 Jan 2026",
  current_points: 15.8,
  total_points: 23,
  target: 20,
  workflow_completed: 2,
  workflow_total: 6,
  icon: "fas fa-briefcase",
  theme: { gradientFrom: "#3b82f6", gradientTo: "#06b6d4" },
  steps: [
    {
      id: "mc-1",
      title: "Update Organisational Structure",
      description:
        "Create current organogram showing all management levels and reporting lines",
      status: "completed",
      due: "05 Jan 2026",
      owner_initials: "TM",
      owner_name: "Thabo Molefe",
      owner_role: "HR Manager",
      owner_email: "thabo.molefe@company.co.za",
      owner_number: "+27 84 345 6789",
      owner_role_desc: "Oversees organizational structure and employment equity",
      required_documents: ["Organogram", "Management Structure Report"],
    },
    {
      id: "mc-2",
      title: "Submit EE Report to DOL",
      description:
        "Complete and submit Employment Equity Report (EEA2 & EEA4) to Department of Labour",
      status: "completed",
      due: "15 Jan 2026",
      owner_initials: "TM",
      owner_name: "Thabo Molefe",
      owner_role: "HR Manager",
      owner_email: "thabo.molefe@company.co.za",
      owner_number: "+27 84 345 6789",
      owner_role_desc: "Oversees organizational structure and employment equity",
      required_documents: ["EEA2 Form", "EEA4 Form", "DOL Acknowledgement"],
    },
    {
      id: "mc-3",
      title: "Compile Board & Exec Appointments",
      description:
        "Collect appointment letters and contracts for all board and executive members",
      status: "in_progress",
      due: "22 Jan 2026",
      owner_initials: "TM",
      owner_name: "Thabo Molefe",
      owner_role: "HR Manager",
      owner_email: "thabo.molefe@company.co.za",
      owner_number: "+27 84 345 6789",
      owner_role_desc: "Oversees organizational structure and employment equity",
      required_documents: ["Appointment Letters", "Contracts / Terms of Reference"],
    },
    {
      id: "mc-4",
      title: "Compile Executive Demographics",
      description:
        "Document demographic details for board and executive management positions",
      status: "pending",
      due: "24 Jan 2026",
      owner_initials: "TM",
      owner_name: "Thabo Molefe",
      owner_role: "HR Manager",
      owner_email: "thabo.molefe@company.co.za",
      owner_number: "+27 84 345 6789",
      owner_role_desc: "Oversees organizational structure and employment equity",
      required_documents: ["ID Copies", "Demographic Summary"],
    },
    {
      id: "mc-5",
      title: "Prepare Payroll Analysis",
      description:
        "Extract payroll data by race, gender, and occupational level",
      status: "pending",
      due: "27 Jan 2026",
      owner_initials: "FN",
      owner_name: "Finance Team",
      owner_role: "Payroll",
      owner_email: "finance.team@company.co.za",
      owner_number: "+27 91 912 3456",
      owner_role_desc: "Manages payroll and financial reporting",
      required_documents: ["Payroll Extract", "HR Employee Register"],
    },
    {
      id: "mc-6",
      title: "Submit Management Control Pack",
      description:
        "Compile and submit management control evidence for verification",
      status: "pending",
      due: "31 Jan 2026",
      owner_initials: "JD",
      owner_name: "John Dlamini",
      owner_role: "BEE Manager",
      owner_email: "john.dlamini@company.co.za",
      owner_number: "+27 90 901 2345",
      owner_role_desc: "Oversees all BEE compliance and verification processes",
      required_documents: ["Management Control Pack", "EE Summary Report"],
    },
  ],
};
